/** Defaults for future strokes are UI preferences, never edits to selected objects. */
export class NativePenSettings {
  private field = document.getElementById(
    "drawing-smoothing",
  ) as HTMLInputElement;
  private range = document.getElementById(
    "drawing-smoothing-range",
  ) as HTMLInputElement;
  private value = 0;
  private before: number | null = null;
  private blocked = false;
  private key = "creatorenginepro-native-pen-smoothing-v1";
  constructor(private changed: () => void) {
    const proxy = document.getElementById(
      "compact-drawing-smoothing",
    ) as HTMLInputElement;
    const popup = proxy.closest<HTMLElement>(".native-property-popup")!;
    const slider = popup.querySelector<HTMLInputElement>(
      'input[type="range"]',
    )!;
    popup.classList.add("native-popup", "native-properties");
    slider.classList.remove("native-original-vertical");
    const heading = document.createElement("label"),
      control = document.createElement("div");
    heading.className = "native-range-heading";
    heading.append("Сглаживание", proxy);
    control.className = "native-range-control is-vertical";
    control.append(heading, slider);
    popup.append(control);
    try {
      const saved = Number(localStorage.getItem(this.key));
      if (Number.isFinite(saved))
        this.value = Math.max(0, Math.min(100, Math.round(saved)));
    } catch {
      /* Browser storage can be unavailable. */
    }
    const begin = () => {
      this.blocked = false;
      this.before ??= this.value;
    };
    const input = (source: HTMLInputElement) => {
      if (this.blocked || !source.value.trim()) return;
      this.before ??= this.value;
      const next = Number(source.value);
      if (!Number.isFinite(next)) return;
      this.value = Math.max(0, Math.min(100, Math.round(next)));
      this.changed();
    };
    this.field.oninput = () => input(this.field);
    this.range.oninput = () => input(this.range);
    this.field.onchange = this.range.onchange = () => this.finish();
    for (const control of [
      this.field,
      this.range,
      ...document.querySelectorAll<HTMLInputElement>(
        '[data-original-source="drawing-smoothing"]',
      ),
    ]) {
      control.addEventListener("pointerdown", begin);
      control.addEventListener("pointercancel", () => this.cancel());
      control.addEventListener("blur", () => this.finish());
      control.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          this.cancel();
          control.blur();
        } else begin();
      });
    }
    document.addEventListener(
      "pointerdown",
      (e) => {
        if (
          !(e.target as HTMLElement).closest(
            '#drawing-smoothing-row,[data-original-control="drawing-smoothing"],.native-property-anchor:has([data-original-source="drawing-smoothing"])',
          )
        )
          this.finish();
      },
      true,
    );
    window.addEventListener("pointerup", () =>
      queueMicrotask(() => this.finish()),
    );
    window.addEventListener("blur", () => this.cancel());
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) this.cancel();
    });
    this.render(false);
  }
  get amount() {
    return this.value;
  }
  private finish() {
    if (this.before === null) return;
    this.before = null;
    try {
      localStorage.setItem(this.key, String(this.value));
    } catch {
      /* UI preference only. */
    }
    this.changed();
  }
  private cancel() {
    if (this.before === null) return;
    this.value = this.before;
    this.before = null;
    this.blocked = true;
    this.changed();
  }
  render(visible: boolean) {
    document.getElementById("drawing-smoothing-row")!.hidden = !visible;
    const trigger = document.querySelector<HTMLElement>(
      '[data-original-control="drawing-smoothing"]',
    );
    if (trigger) trigger.parentElement!.hidden = !visible;
    for (const control of [
      this.field,
      this.range,
      ...document.querySelectorAll<HTMLInputElement>(
        '[data-original-source="drawing-smoothing"]',
      ),
    ])
      if (control !== document.activeElement || control.type === "range")
        control.value = String(this.value);
  }
}
